import * as types from './types';
import * as samples from './samples';
import * as search_criteria from './search_criteria';

const Constants = { ...types, ...samples, search_criteria };

export default Constants;
